import React from "react";
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  TextInput,
  SelectInput,
  Filter,
} from "react-admin";

const pageChoices = [
  { id: "sellers", name: "Distribuidores" },
  { id: "service", name: "Servicio técnico" },
  { id: "blog", name: "Blog" },
  { id: "contact", name: "Contacto" },
];

const BannersFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Nombre" source="name_contains" alwaysOn />
    <SelectInput label="Página" source="page" choices={pageChoices} />
  </Filter>
);

const BannersTitle = () => <span>Banners</span>;

export const BannersList = (props) => (
  <List
    filters={<BannersFilter />}
    title={<BannersTitle />}
    {...props}
    sort={{ field: "id", order: "ASC" }}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" label="ID" />
      <TextField source="name" label="Nombre" />
      <TextField source="link" label="URL" />
      <TextField source="page" label="Página" />
      <BooleanField source="active" label="Activo" />
      <EditButton />
    </Datagrid>
  </List>
);
